import type { CSSProperties, FC } from 'react'

type ProgressiveBlurProps = {
    position: 'top' | 'bottom'
    height?: number
}

const LAYERS = [0.078, 0.156, 0.3125, 0.625, 1.25, 2.5, 5, 10]

/**
 * Stacked backdrop-filter layers with stepped gradient masks, reproducing the
 * gradual blur strips pinned to the top and bottom of the original site.
 */
export const ProgressiveBlur: FC<ProgressiveBlurProps> = ({ position, height = 72 }) => {
    return (
        <div
            aria-hidden='true'
            className='pointer-events-none fixed inset-x-0 z-40'
            style={position === 'top' ? { height, top: 0 } : { height, bottom: 0 }}
        >
            {LAYERS.map((blur, i) => {
                const start = (i / LAYERS.length) * 100
                const mid = ((i + 1) / LAYERS.length) * 100
                const end = ((i + 2) / LAYERS.length) * 100

                const direction = position === 'top' ? 'to top' : 'to bottom'
                const mask = `linear-gradient(${direction}, transparent ${start}%, #000 ${mid}%, #000 ${end}%, transparent ${Math.min(end + 12.5, 100)}%)`

                const style: CSSProperties = {
                    backdropFilter: `blur(${blur}px)`,
                    WebkitBackdropFilter: `blur(${blur}px)`,
                    maskImage: mask,
                    WebkitMaskImage: mask
                }

                return <div key={blur} className='absolute inset-0' style={style} />
            })}
        </div>
    )
}
